import { render } from "./TheFooter.vue?vue&type=template&id=d96122a0"
import script from "./TheFooter.vue?vue&type=script&lang=ts"
export * from "./TheFooter.vue?vue&type=script&lang=ts"

import "./TheFooter.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script